var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnicargoSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1685_55955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.425 16.3951L13.141 11.9395C14.2425 10.6301 14.846 8.98262 14.846 7.26749C14.846 3.26026 11.5858 0 7.57853 0C3.5713 0 0.311035 3.26026 0.311035 7.26749C0.311035 11.2747 3.5713 14.535 7.57853 14.535C9.0829 14.535 10.5165 14.0812 11.7422 13.2199L16.0587 17.7093C16.2392 17.8967 16.4818 18 16.7419 18C16.988 18 17.2215 17.9062 17.3988 17.7355C17.7755 17.3731 17.7875 16.7721 17.425 16.3951ZM7.57853 1.89587C10.5405 1.89587 12.9502 4.30552 12.9502 7.26749C12.9502 10.2295 10.5405 12.6391 7.57853 12.6391C4.61655 12.6391 2.2069 10.2295 2.2069 7.26749C2.2069 4.30552 4.61655 1.89587 7.57853 1.89587Z",
    fill: "#1D4650"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1685_55955"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnicargoSearchIcon);
export default __webpack_public_path__ + "static/media/UnicargoSearchIcon.66a30f36108577af58514943df94863e.svg";
export { ForwardRef as ReactComponent };